import { msg } from '@lingui/core/macro';

/** GraphQL `MEDIA_MANAGER_TEMPLATE_NAME_CONFLICT`. */
export const TEMPLATE_NAME_CONFLICT_CODE = 21409;

/**
 * Message shown when the server rejects a name — same wording as the client-side check.
 * A descriptor: translate at the call site with `t(TEMPLATE_NAME_CONFLICT_MESSAGE)`.
 */
export const TEMPLATE_NAME_CONFLICT_MESSAGE = msg`Такое название уже существует, придумайте новое`;

function readCode(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

/**
 * True when a write failed because the name is already taken in that scope.
 * Walks RTK Query (`error.data[0].extensions.code`) and repository-thrown
 * `UserError` (`error.extensions.code`).
 */
export function isTemplateNameConflict(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as {
    extensions?: { code?: unknown };
    data?: { extensions?: { code?: unknown } }[] | { errors?: { extensions?: { code?: unknown } }[] };
  };
  const fromThrown = readCode(e.extensions?.code);
  const fromRtkArray = Array.isArray(e.data) ? readCode(e.data[0]?.extensions?.code) : undefined;
  const fromNested = !Array.isArray(e.data) ? readCode(e.data?.errors?.[0]?.extensions?.code) : undefined;
  return (fromThrown ?? fromRtkArray ?? fromNested) === TEMPLATE_NAME_CONFLICT_CODE;
}

/**
 * Names are compared case- and whitespace-insensitively, matching the unique
 * index — otherwise the client would accept a name the DB then rejects.
 */
export function normalizeTemplateName(name: string): string {
  return name.trim().toLowerCase();
}
